import first from 'lodash/first';

import { CoachNode } from 'src/generated/webapp_gql';

const getProviderInitials = (provider: CoachNode) => {
    return `${first(provider.firstName)}${first(provider.lastName)}`;
};

export default getProviderInitials;
